<script lang="ts" setup>
const emit = defineEmits(["back"]);
const localePath = useLocalePath();
const goToRescue = () => {
  navigateTo(localePath("/rescue"));
  useModalManager().closeModal("modal-user-wallet-locked");
};
</script>

<template>
  <div class="flex flex-col items-center gap-4 max-w-md mx-auto mb-4 mt-8">
    <h3 class="text-neutral-200 text-2xl font-bold">
      {{ $t("main.walletLock.restoreAccount") }}
    </h3>
    <p class="text-neutral-300 max-w-sm text-center">
      {{ $t("main.walletLock.lostAccessRestoreAccount") }}
    </p>
    <div class="w-full flex gap-4 py-4">
      <BaseButtonCancel
        :text="$t('Cancel')"
        size="lg"
        class="w-full"
        @click="emit('back')" />
      <BaseButtonSubmit
        :text="$t('main.walletLock.restoreAccount')"
        size="lg"
        class="w-full"
        @click="goToRescue" />
    </div>
  </div>
</template>
